import { render, staticRenderFns } from "./kycUpdate.vue?vue&type=template&id=6213f6a6&"
import script from "./kycUpdate.vue?vue&type=script&lang=js&"
export * from "./kycUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports